module.exports = __webpack_public_path__ + "static/media/oval_out.13fc9d69.svg";